import BlurFade from '#app/components/magicui/blur-fade.tsx'
import { ThemeSwitchSegmented } from '#app/routes/resources/theme-switch.tsx'
import { useRequestInfo } from '#app/utils/request-info.ts'

const BLUR_FADE_DELAY = 0.04

const Settings = () => {
	const requestInfo = useRequestInfo()
	return (
		<section id="settings" className="container">
			<div className="flex min-h-0 flex-col gap-y-3">
				<BlurFade delay={BLUR_FADE_DELAY * 5}>
					<h2 className="text-xl font-bold">Settings</h2>
				</BlurFade>
				<BlurFade delay={BLUR_FADE_DELAY * 6}>
					<div className="flex flex-col gap-2 text-sm">
						<span className="text-muted-foreground">Theme</span>
						<ThemeSwitchSegmented
							userPreference={requestInfo.userPrefs.theme}
						/>
					</div>
				</BlurFade>
			</div>
		</section>
	)
}

export default Settings
